
import * as React from 'react';
import { fluentSvgIconStyles } from '../../../../styles/iconStyles';

export const MoreVertical20Regular: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return <svg role="img" focusable="false" aria-hidden viewBox="0 0 20 20" width={20} height={20} fill="currentColor" className={props.className} style={{ ...props.style, ...fluentSvgIconStyles }} onClick={props.onClick}>
        <path
            d="M10 6a1.25 1.25 0 1 1 0-2.5A1.25 1.25 0 0 1 10 6Zm0 5.25a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5Zm-1.25 4a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0Z"
            fill="currentColor"
        />
    </svg>
}